import { configFetch as fetch } from '@laigu/utils';

export const spacePhoneCheckApi = data => {
  return fetch({
    url: `/unified-api/crm/v1/phone_check`,
    method: 'POST',
    ignoreLogin: true,
    data
  });
};
